<script setup lang="ts">
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import faqData from "@/data/faq.json"
import type { FAQItem } from "@/lib/types"

const faqItems = faqData.map((item: FAQItem) => ({
  value: `${item.id}`,
  title: item.title,
  content: item.content
}))
</script>


<template>
    

     <div class="mx-2 px-6 lg:px-8">
                <div class="mx-auto max-w-4xl text-center">
                    <h2 class="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
                        Frequently Asked Questions
                    </h2>
                    <p class="mt-4 text-lg leading-8 text-muted-foreground">
                        Answers to common questions about Jittr and its features.
                    </p>
                </div>

                <div class="mt-10 max-w-3xl mx-auto">

  <Accordion type="single" class="w-full" collapsible>
    <AccordionItem v-for="item in faqItems" :key="item.value" :value="item.value">
      <AccordionTrigger>{{ item.title }}</AccordionTrigger>
      <AccordionContent>
        {{ item.content }}
      </AccordionContent>
    </AccordionItem>
  </Accordion>
                </div>

  </div>

</template>